module.exports = __webpack_public_path__ + "static/media/gamepad.51738763.svg";